import { getLocalStorage, setLocalStorage } from '@/utils/localStoreHelper';
import { LOCAL_KEY_USER_UUID } from '@/constants/localStorageKeys';
import { v4 as uuidv4 } from 'uuid';

export const getDeviceUid = () => {
  let deviceUid = getLocalStorage(LOCAL_KEY_USER_UUID);

  if (!deviceUid) {
    deviceUid = uuidv4();
    setLocalStorage(LOCAL_KEY_USER_UUID, deviceUid);
  }

  return deviceUid;
};

export default getDeviceUid;
